import type { ProductConfig } from '#types/config/components/product'

export default 'https://assets.thenorthface.com/t_img/f_auto,c_fill,w_340,h_340/dpr_2.0/na' satisfies ProductConfig['defaultImageUrl']
